import ViewOptionEvent from '@adobe-fonts/site/events/ViewOptionEvent.js';

export function registerEventHandlers(element) {
  element.addEventListener(ViewOptionEvent.EVENT_NAME, event => handleViewOptionChange(event, element));
}

/**
 * Toggle the view of the elements between list and grid with data attribute `data-toggle-view`
 *
 * @param {ViewOptionEvent} event
 */
export function handleViewOptionChange(event, parent) {
  if (!(event instanceof ViewOptionEvent)) {
    return;
  }
  const isListView = event.detail.listView;
  const elements = parent.querySelectorAll('[data-toggle-view]');

  elements.forEach(function(element) {
    element.toggleAttribute('listview', isListView);
  });
}
